import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-basesoportunos',
  templateUrl: './basesoportunos.component.html',
  styleUrls: ['./basesoportunos.component.scss']
})
export class BasesoportunosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
